var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.808594,
    y: 0.515625,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#FBE882",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.57 45.371L37.3467 23.874C37.0265 23.3112 36.452 22.9746 35.8086 22.9746C35.1652 22.9746 34.5907 23.3112 34.2705 23.874L22.0472 45.371C21.7258 45.9362 21.7293 46.6098 22.0565 47.1721C22.3785 47.7257 22.9495 48.0558 23.5853 48.0558H48.0319C48.6677 48.0558 49.2387 47.7257 49.5607 47.1721C49.8879 46.6098 49.8914 45.9367 49.57 45.371ZM36.9752 43.9728C36.9752 44.2948 36.715 44.5561 36.393 44.5561C36.0361 44.5561 35.5811 44.5561 35.2241 44.5561C34.9022 44.5561 34.642 44.2948 34.642 43.9728V42.8063C34.642 42.4843 34.9022 42.223 35.2241 42.223C35.5811 42.223 36.0361 42.223 36.3925 42.223C36.715 42.223 36.9752 42.4843 36.9752 42.8063V43.9728ZM36.9752 39.8898C36.9752 40.2118 36.7139 40.4731 36.3919 40.4731C36.0349 40.4731 35.5799 40.4731 35.2236 40.4731C34.901 40.4731 34.642 40.2118 34.642 39.8898V31.7239C34.642 31.4019 34.9022 31.1406 35.2241 31.1406C35.5811 31.1406 36.0361 31.1406 36.3925 31.1406C36.715 31.1406 36.9752 31.4019 36.9752 31.7239V39.8898Z",
    fill: "#FBE882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.eeb4b8c686e89347bb1ca0dfc925ea88.svg";
export { ForwardRef as ReactComponent };